var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-template',{scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('main-kind-contents')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }